// extracted by mini-css-extract-plugin
export default {"orderConfirmedModal":"ServerDownModal_orderConfirmedModal__m1piZ","starGreen":"ServerDownModal_starGreen__ZAG0q","starBlack":"ServerDownModal_starBlack__EJ7c8"};